import FormDefault from "../../../components/Forms/FormDefault";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { requestAuth } from "../../../components/services/RequestService";
import { defaultCompanyValues } from "./EditCompany";


const CreateCompany = (props) => {
  const { onClose, reload, handleGetCompany } = props;

  return (
    <div>
      <FormDefault
        tittle="Crear nueva compañía"
        fields={
          [
            ...defaultCompanyValues,
            {
              label: "Actividad comercial",
              name: "commercialActivityCreate",
              placeholder: "Introduzca...",
              urlApi: "/dropdown/tiposMeMercaderia/options",
              typeInput: "selectGetMultiple",
              value: "name",
              labelOption: "name",
            },
          ]
        }
        initialValues={{
          Num: "",
          Nit: "",
          Ci: "",
          RazonSocial: "",
          Email: "",
          categoria: "",
          Phone: "",
          Direccion: "",
          Ciudad: "",
          Gps: "",
          LegalRepresentativeName: "",
          LegalRepresentativeCI: "",
          LegalRepresentativeCIEmision: "",
          commercialActivityCreate: null
        }}
        validationSchema={Yup.object().shape({
          Nit: Yup.string().required("Este campo es obligatorio"),
          RazonSocial: Yup.string().required("Este campo es obligatorio"),
        })}
        onSubmit={async (values) => {
          await requestAuth("post", "company/Register", values)
            .then((res) => {
              reload(res.data);
              onClose();
              (handleGetCompany && handleGetCompany({ id: res.data.companyId }, reload()))
              toast.success("Envio exitoso");
            })
            .catch((response) => {
              toast.error(
                response.response.data
                  ? response.response.data
                  : "Se ha producido un error al enviar"
              );
            });
        }}
        buttonName="Enviar"
      />
    </div>
  );
}

export default CreateCompany;